import gql from 'graphql-tag';
export const GET_USER = gql `
  query User($id: UUID!, $appIds: [String!]) {
    user(id: $id) {
      id
      firstName
      lastName
      email
      countryCode
      company {
        id
        tenantId
        blackList
      }
      locale
      phone
      addressLine1
      addressLine2
      zipCode
      city
      state
      roles
      agreements {
        serviceAgreements
        expired
      }
      settings {
        preferredAppId
        dateFormat
        timeFormat
        regionalSettingsName
      }
      personas
      permissions(groupIds: $appIds) {
        group
        roles
      }
    }
  }
`;
//# sourceMappingURL=getUser.js.map